export const injectConditionalArrayItems = <T>(condition: boolean, items: T | T[]) => {
  return condition ? (Array.isArray(items) ? items : [items]) : [];
};

export const injectConditionalObject = <T extends Record<string, unknown>>(condition: boolean, properties: T) => {
  return condition ? properties : {};
};
